<template lang="pug">
  div(class="infographics-block")
    eyecatch
    div(class="infographics-wrap")
      data-block
      locus
      in-future
    footer-block
</template>
<script>
  import DataBlock from 'modules/components/Event/Infographics/Data.vue';
  import Eyecatch from 'modules/components/Event/Infographics/Eyecatch.vue';
  import FooterBlock from 'modules/components/Event/Infographics/Footer.vue';
  import Locus from 'modules/components/Event/Infographics/Locus.vue';
  import InFuture from 'modules/components/Event/Infographics/InFuture.vue';

  export default {
    components: {
      DataBlock,
      Eyecatch,
      FooterBlock,
      Locus,
      InFuture,
    },
  };
</script>
<style lang="scss" scoped>
  @import 'stylesheets/pages/event/infographics/_variables.scss';

  .infographics-block {
    overflow: hidden;
    background-image: url('~images/Event/Infographics/background_wrapper@2x.png');
    background-size: 1280px auto;
    background-position: center top;
  }

  .infographics-wrap {
    max-width: 1024px;
    width: 100%;
    background-color: $c-khaki;
    margin-left: auto;
    margin-right: auto;
  }
</style>
